exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h2{text-align:center}.activation__wrapper{display:-ms-flexbox;display:flex;-ms-flex-flow:column wrap;flex-flow:column wrap;padding:100px 15px;-ms-flex-align:center;align-items:center}.buttons-group{-ms-flex-flow:row wrap;flex-flow:row wrap}.buttons-group .app-btn{margin:0 15px 15px}.title-deactivated{font-size:22px;font-weight:700}@media (max-width:768px){.buttons-group .app-btn{margin:0 auto 15px;display:block;width:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b56e3a4","scoped":false,"hasInlineConfig":true}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/activate-account/activate-account.vue
// module id = 854
// module chunks = 0